import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";

const GameUpload = ({ selectedFile, setSelectedFile }) => {
  const onDrop = useCallback(async (acceptedFiles) => {
    if (acceptedFiles.length === 0) {
      setSelectedFile(null);
      console.log("Invalid file type!");
      return;
    }
    if (acceptedFiles.length > 0) {
      setSelectedFile(acceptedFiles[0]);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    webkitdirectory: true,
    accept: { "application/zip": [".zip"] },
    maxFiles: 1,
  });

  return (
    <div {...getRootProps()} className="dropzone">
      <input
        {...getInputProps()}
        style={{
          border: "2px dashed #007bff",
          padding: "40px",
          textAlign: "center",
        }}
      />
      {isDragActive ? (
        <p>Drop the ZIP file here...</p>
      ) : (
        <p>Drag & drop a ZIP file here, or click to select one</p>
      )}
    </div>
  );
};

export default GameUpload;
